export default function AboutData() {
    return {
        title: "About Whole Life Insurance",
        content:
            "Simplified issue whole life insurance is permanent insurance you can easily purchase without a medical exam. The policy will not expire, as long as the premiums are paid in full. Your cost and death benefit are guaranteed for the rest of your life. Typically for those between 18 and 65 years of age, this type of coverage can be secured online in minutes, and builds tax-deferred cash value over time with a guaranteed interest rate of 4 percent.",
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Perm/AboutData.js